import React, { Component } from 'react';

import PropTypes from 'prop-types';
import i18n from 'i18n-react';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class MultipleDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      options: [],
      selectedOption: i18n.translate('trainingScreens.choose'),
      answerFeedback: '',
    };
  }

  componentWillMount() {
    this.setState({ options: this.setAnswers() });
  }

  setAnswers() {
    const { answer } = this.props;
    const dropdown = [<option hidden value="" key={`option_${Date.now()}`}>{i18n.translate('questions.dropdown')}</option>];
    dropdown.unshift(<option value={i18n.translate('questions.dropdown')} key={`option_${Date.now()}`}>{i18n.translate('questions.dropdown')}</option>);
    answer.forEach((answerText, i) => {
      const key = `option_${i}`;
      dropdown.push(<option value={answerText} key={key}>{answerText}</option>);
    });
    return dropdown;
  }

  checkAnswer(e) {
    const { value } = e.target;
    const {
      answer,
      answersCorrect,
      contentComplete,
      correctAnswerText,
      error,
      incorrectAnswerText,
    } = this.props;
    this.setState({ selectedOption: value });
    if (value.length > 0 && ((answersCorrect[answer.indexOf(value)] === 'true') || (answersCorrect[answer.indexOf(value)] === true))) {
      this.setState({ answerFeedback: 'correct' });
      toast.success(correctAnswerText, {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      contentComplete();
    } else {
      this.setState({ answerFeedback: 'wrong' });
      toast.error(incorrectAnswerText, {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      error(true);
    }
  }

  render() {
    const {
      disableHeader,
      error,
      question,
    } = this.props;

    const {
      options,
      selectedOption,
      answerFeedback,
    } = this.state;

    return (
      <div className="container__question">
        {!disableHeader && <div className="container__question--image" />}
        <div className="container__question--content multipleDropdown">
          <h4>{question}</h4>
          <div className={`select__Container ${answerFeedback}`}>
            <select value={selectedOption} onChange={e => this.checkAnswer(e)}>
              {options}
            </select>
          </div>
          <ToastContainer
            draggablePercent={70}
          />
          {error()}
        </div>
      </div>
    );
  }
}

MultipleDropdown.propTypes = {
  answer: PropTypes.arrayOf(PropTypes.string).isRequired,
  answersCorrect: PropTypes.arrayOf(PropTypes.string).isRequired,
  contentComplete: PropTypes.func.isRequired,
  correctAnswerText: PropTypes.string,
  incorrectAnswerText: PropTypes.string,
  question: PropTypes.string.isRequired,
  error: PropTypes.func,
  disableHeader: PropTypes.bool,
};

MultipleDropdown.defaultProps = {
  correctAnswerText: '',
  incorrectAnswerText: '',
  error: () => {},
  disableHeader: false,
};
